import { useState } from "react";
import { toast } from "sonner";
import { BookmarkPlus, LayoutTemplate, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api, errMsg, useApi } from "@/lib/api";

const FIELDS = ["diagnosis", "advice", "warnings", "investigations"];

export function RxTemplates({ rx, onApply }) {
  const list = useApi("/doctor/rx-templates");
  const [name, setName] = useState("");
  const [saveOpen, setSaveOpen] = useState(false);
  const save = async () => {
    const items = rx.items.filter((i) => i.medicine.trim());
    try {
      const { data } = await api.post("/doctor/rx-templates", { name, items, ...Object.fromEntries(FIELDS.map((k) => [k, rx[k] || ""])) });
      toast.success(data.updated ? "Template updated" : "Template saved"); setName(""); setSaveOpen(false); list.reload();
    } catch (e) { toast.error(errMsg(e)); }
  };
  const del = async (t) => { if (!window.confirm(`Delete template "${t.name}"?`)) return; try { await api.delete(`/doctor/rx-templates/${t.id}`); list.reload(); } catch (e) { toast.error(errMsg(e)); } };
  const tpls = list.data || [];
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-xl bg-[#F7F9FA] p-2.5" data-testid="rx-templates-bar">
      <LayoutTemplate className="h-4 w-4 text-[#086477]" />
      {tpls.length === 0 ? <span className="text-xs muted">No templates yet – build a prescription and save it as a template.</span>
        : tpls.map((t) => (
          <span key={t.id} className="group inline-flex items-center rounded-full border border-[#E2E8ED] bg-white text-xs">
            <button type="button" className="px-3 py-1.5 font-medium hover:text-[#086B2D]" onClick={() => { onApply(t); toast.success(`Applied "${t.name}" – review before finalizing`); }} data-testid={`rx-template-apply-${t.id}`}>{t.name}</button>
            <button type="button" className="pr-2 opacity-50 hover:opacity-100" aria-label={`Delete ${t.name}`} onClick={() => del(t)} data-testid={`rx-template-delete-${t.id}`}><Trash2 className="h-3 w-3" /></button>
          </span>))}
      <Popover open={saveOpen} onOpenChange={setSaveOpen}>
        <PopoverTrigger asChild><Button size="sm" variant="ghost" className="ml-auto h-8" data-testid="rx-template-save-open"><BookmarkPlus className="h-4 w-4 mr-1" />Save as template</Button></PopoverTrigger>
        <PopoverContent className="w-72 space-y-2">
          <p className="text-sm font-medium">Template name</p>
          <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g. Viral fever – adult" data-testid="rx-template-name" />
          <Button size="sm" className="w-full" disabled={name.trim().length < 2} onClick={save} data-testid="rx-template-save-btn">Save</Button>
          <p className="text-[11px] muted">Saves medicines, diagnosis, advice, warnings & investigations. Same name overwrites.</p>
        </PopoverContent>
      </Popover>
    </div>
  );
}
